import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SectorPopupDataComponent } from '../sector-popup-data/sector-popup-data.component';
import { Router } from '@angular/router';
import { ExportExcelService } from 'app/service/export-excel.service';
import { environment } from '../../../environments/environment';
import { CpmService } from 'app/service/cpm.service';

@Component({
  selector: 'app-sector-popup',
  templateUrl: './sector-popup.component.html',
  styleUrls: ['./sector-popup.component.scss']
})
export class SectorPopupComponent implements OnInit, AfterViewInit {
  @ViewChild(SectorPopupDataComponent)
  sectorPopupData: SectorPopupDataComponent;

  constructor(
    private excelService: ExportExcelService,
    private router: Router,
    private cpmService: CpmService
  ) { }

  ngOnInit() { }

  exportFunctionsSectorPopup() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailSectorPopup(
        this.cpmService,
        this.sectorPopupData
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintSectorPopup(
        this.sectorPopupData
      )
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfSectorPopup(
        this.sectorPopupData
      )
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelSectorPopup(
        this.excelService,
        this.sectorPopupData
      )
    );

    return arrayOfFunctions;
  }

  exportEmailSectorPopup(service, sectorPopupData) {
    return function mailSectorPopup() {
      service.saveSectorPopupData(
        sectorPopupData.sectorpopupValue1,
        sectorPopupData.sectorpopupValue2,
        sectorPopupData.indexName,
        sectorPopupData.marketName,
        sectorPopupData.indexLevel
      ).then(filename => {
        const subject = 'SectorProfit-Data';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintSectorPopup = function (sectorPopupData) {
    return function printSectorPopup() {
      // tslint:disable-next-line:max-line-length
      console.log(sectorPopupData.sectorpopupValue1, sectorPopupData.sectorpopupValue2, sectorPopupData.indexName, sectorPopupData.marketName, sectorPopupData.indexLevel)
      const popupWin = window.open(
        // tslint:disable-next-line:max-line-length
        `/#/sectorPopupData/${sectorPopupData.sectorpopupValue1}/${sectorPopupData.sectorpopupValue2}/${sectorPopupData.indexName}/${sectorPopupData.marketName}/${sectorPopupData.indexLevel}`,
        '_blank',
        'width=720px,height=1024px'
      );
    };
  };

  exportPdfSectorPopup = function (sectorPopupData) {
    const service = this.cpmService;
    return function pdfSectorPopup() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/sectorPopupData?radioByView=${
        sectorPopupData.sectorpopupValue1
        }&radioByFinancial=${sectorPopupData.sectorpopupValue2}&indexN=${
        sectorPopupData.indexName
        }&marketL=${sectorPopupData.marketName}&indexL=${
        sectorPopupData.indexLevel
        }`
      );
    };
  };

  exportExcelSectorPopup(service, sectorPopupData) {
    return function excelSectorPopup() {
      if (sectorPopupData.sectorpopupValue1 === 'top') {
        service.exportExcelsectorPopupTopRank(sectorPopupData.exportExcelTopRankCompany(), 'Top Rank Company')
      } else {
        service.exportExcelsectorPopupTrendAnalysis(sectorPopupData.exportExcelTrendAnalysis(), 'Trend Analysis')
      }
    };
  };
  ngAfterViewInit() {}

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/sector-popup/sector-popup.component.ts